import React from 'react'
import { isLoading, isErrored, LoadingInstance, ErroredInstance } from '@rwwa/rwwa-data-access'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { List as ImmutableList } from 'immutable'
import { connect } from '@core/Components/HOCs/connect'
import { List, ListItem } from '@core/Components/List'
import { Message, ErrorMessage } from '@core/Components/Messages'
import { MainContainer } from '@core/Components/Containers'
import { PoolKeys } from '@core/Data/Racing/pools'
import { Jackpot, JackpotLoading } from './Components/Jackpot'

export const Jackpots = () => <ConnectedJackpots poolKeys='currentJackpotsByDate' />

const ConnectedJackpots = connect({ poolKeys: PoolKeys })(({ poolKeys }) => (
  <JackpotsComponent poolKeys={poolKeys} />
))

const JackpotsComponent: React.FC<{
  poolKeys: ImmutableList<string> | typeof LoadingInstance | typeof ErroredInstance
}> = ({ poolKeys }) => {
  const testId = { 'data-tid-jackpots-container': '' }
  return (
    <MainContainer {...testId}>
      <PageHeader title='Jackpots' />
      <JackpotsList poolKeys={poolKeys} />
    </MainContainer>
  )
}

const JackpotsList: React.FC<{
  poolKeys: ImmutableList<string> | typeof LoadingInstance | typeof ErroredInstance
}> = ({ poolKeys }) => {
  if (isLoading(poolKeys)) {
    return (
      <List data-testid='jackpotlist-loading'>
        <ListItem>
          <JackpotLoading />
        </ListItem>
      </List>
    )
  }

  if (isErrored(poolKeys)) {
    return <ErrorMessage>Error loading Jackpots</ErrorMessage>
  }

  if (!poolKeys.size) {
    return <Message>No Jackpots for today</Message>
  }

  return (
    <List>
      {poolKeys.toArray().map(poolKey => (
        <ListItem key={poolKey}>
          <Jackpot pool={poolKey} />
        </ListItem>
      ))}
    </List>
  )
}
